module.exports = __webpack_public_path__ + "static/media/4.0e881c3e.jpg";